import { AxiosResponse } from 'axios';
import { GetStationsVm } from './get-stations.vm';
import { instance } from 'api/core';
import { plainToClass } from 'class-transformer';
import { CallbackObject } from 'api/core/get-page-function';

export const getStations = async (serverId: string, offset: string, callback: CallbackObject<GetStationsVm>) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
      offset: offset,
      serverId: serverId,
    },
  };

  try {
    const res: AxiosResponse = await instance.get(`/asrs/stations`, config);
    callback.success(plainToClass(GetStationsVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
